/* [CM] Menú móvil v2 — panel de búsqueda + integración con el drawer del tema. */
(function () {
  if (customElements.get('menu-drawer-cm')) return;

  /* QA: ?mmv2=1 activa la variante sin Intelligems (persiste en la sesión); ?mmv2=0 la apaga. */
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.has('mmv2')) window.sessionStorage.setItem('mmv2', params.get('mmv2'));
    if (window.sessionStorage.getItem('mmv2') === '1') {
      const style = document.createElement('style');
      style.id = 'mmv2-qa';
      style.textContent =
        '#menu-drawer > .menu-drawer__inner-container{display:none!important}' +
        '#menu-drawer > menu-drawer-cm{display:flex!important}' +
        '#menu-drawer{background:transparent;border:0;filter:none;width:calc(100vw - 20px)}';
      document.head.appendChild(style);
    }
  } catch (error) {
    /* noop */
  }

  class MenuDrawerCM extends HTMLElement {
    connectedCallback() {
      this.details = this.closest('details');
      this.homePanel = this.querySelector('[data-mmv2-panel="home"]');
      this.searchPanel = this.querySelector('[data-mmv2-panel="search"]');
      this.input = this.querySelector('[data-mmv2-input]');
      this.liveResults = this.querySelector('[data-mmv2-live]');
      this.defaultResults = this.querySelector('[data-mmv2-default]');
      this.limit = parseInt(this.dataset.resultsLimit || '6', 10);
      this.cache = {};
      this.controller = null;
      this.timer = null;

      /* Fase captura: el MenuDrawer del tema (global.js) registra click en cada <button>
         del drawer como "cerrar submenú". Cortamos la propagación antes de que llegue. */
      this.addEventListener('click', this.onClick.bind(this), true);
      this.querySelector('[data-mmv2-cart]')?.addEventListener('click', (event) => this.onCartClick(event));

      if (this.input) {
        this.input.addEventListener('input', () => this.onInput());
        this.input.form?.addEventListener('submit', (event) => {
          if (!this.input.value.trim()) event.preventDefault();
        });
      }

      this.details?.addEventListener('toggle', () => {
        if (this.details.open) {
          this.syncBodyClass();
        } else {
          this.reset();
          document.body.classList.remove('mmv2-open');
        }
      });
    }

    /* body.mmv2-open solo cuando v2 es la variante visible (Intelligems o ?mmv2=1);
       en el control (v1) no se toca nada. */
    syncBodyClass() {
      const visible = window.getComputedStyle(this).display !== 'none';
      document.body.classList.toggle('mmv2-open', visible);
    }

    onClick(event) {
      const control = event.target.closest('button');
      if (!control || !this.contains(control)) return;
      event.stopPropagation();
      if (control.hasAttribute('data-mmv2-close')) {
        event.preventDefault();
        this.closeDrawer();
      } else if (control.hasAttribute('data-mmv2-open-search')) {
        event.preventDefault();
        this.openSearch();
      } else if (control.hasAttribute('data-mmv2-close-search')) {
        event.preventDefault();
        this.closeSearch();
      }
    }

    closeDrawer() {
      if (!this.details || !this.details.open) return;
      const summary = this.details.querySelector(':scope > summary');
      if (summary) {
        summary.click();
      } else {
        this.details.removeAttribute('open');
      }
    }

    /* No se hace preventDefault: Kaching Cart intercepta a[href*='/cart'] por delegación
       y abre su drawer; sin app de carrito, el link navega a /cart. */
    onCartClick() {
      this.closeDrawer();
    }

    /* Orden importa: mostrar destino y mover el foco ANTES de ocultar el origen.
       Si el elemento enfocado se oculta, el foco cae a <body> y el focusout
       del MenuDrawer del tema cierra el drawer. */
    openSearch() {
      if (!this.homePanel || !this.searchPanel) return;
      this.searchPanel.hidden = false;
      this.moveFocus(this.input);
      this.homePanel.hidden = true;
    }

    closeSearch() {
      if (!this.homePanel || !this.searchPanel) return;
      this.homePanel.hidden = false;
      this.moveFocus(this.querySelector('[data-mmv2-open-search]'));
      this.searchPanel.hidden = true;
    }

    moveFocus(target) {
      try {
        target?.focus({ preventScroll: true });
      } catch (error) {
        /* noop */
      }
      if (document.activeElement !== target) this.focus({ preventScroll: true });
    }

    reset() {
      this.closeSearch();
      if (this.input) this.input.value = '';
      this.showDefaults();
    }

    onInput() {
      window.clearTimeout(this.timer);
      const query = this.input.value.trim();
      if (!query) {
        this.showDefaults();
        return;
      }
      this.timer = window.setTimeout(() => this.fetchResults(query), 250);
    }

    showDefaults() {
      this.controller?.abort();
      this.removeAttribute('loading');
      if (this.liveResults) this.liveResults.innerHTML = '';
      if (this.defaultResults) this.defaultResults.hidden = false;
    }

    fetchResults(query) {
      const key = query.toLowerCase();
      if (this.cache[key] !== undefined) {
        this.render(this.cache[key]);
        return;
      }

      this.controller?.abort();
      this.controller = new AbortController();
      this.setAttribute('loading', '');

      const base = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
      const url =
        base +
        '?q=' + encodeURIComponent(query) +
        '&resources[type]=product' +
        '&resources[limit]=' + this.limit +
        '&resources[options][unavailable_products]=last' +
        '&section_id=predictive-search-menu';

      fetch(url, { signal: this.controller.signal })
        .then((response) => {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then((text) => {
          const section = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#shopify-section-predictive-search-menu');
          const markup = section ? section.innerHTML : '';
          this.cache[key] = markup;
          if (this.input.value.trim().toLowerCase() === key) this.render(markup);
        })
        .catch((error) => {
          if (error && error.name === 'AbortError') return;
          this.removeAttribute('loading');
        });
    }

    render(markup) {
      if (this.defaultResults) this.defaultResults.hidden = true;
      if (this.liveResults) this.liveResults.innerHTML = markup;
      this.removeAttribute('loading');
    }
  }

  customElements.define('menu-drawer-cm', MenuDrawerCM);
})();
